import { NgModule } from '@angular/core';
import { CoreCommonModule } from '../../utils/modules/core/modules/core-common.module';
import { RouterModule } from '@angular/router';
import { WtfNavigationComponent } from './navigation.component';
import { WtfNavVerticalItemComponent } from './vertical/nav-item/nav-vertical-item.component';
import { WtfNavVerticalCollapseComponent } from './vertical/nav-collapse/nav-vertical-collapse.component';
import { WtfNavVerticalGroupComponent } from './vertical/nav-group/nav-vertical-group.component';
import { WtfNavHorizontalItemComponent } from './horizontal/nav-item/nav-horizontal-item.component';
import { WtfNavHorizontalCollapseComponent } from './horizontal/nav-collapse/nav-horizontal-collapse.component';

@NgModule({
    imports: [
        CoreCommonModule,
        RouterModule
    ],
    exports: [
        WtfNavigationComponent
    ],
    declarations: [
        WtfNavigationComponent,
        WtfNavVerticalGroupComponent,
        WtfNavVerticalItemComponent,
        WtfNavVerticalCollapseComponent,
        WtfNavHorizontalItemComponent,
        WtfNavHorizontalCollapseComponent
    ]
})
export class WtfNavigationModule {
}
